import { PolymerElement, html } from '@polymer/polymer';
import '@polymer/polymer/polymer-legacy.js';
import './style/com-avl-cal-awakening-selector-style.js';

import '@polymer/polymer/lib/elements/dom-repeat.js';
import '@polymer/polymer/lib/elements/dom-if.js';

import '@com/native-bridge';
import '@com/icon';
import '@com/html';
import '@com/radio';
import '@com/button';

class COMAvlCalAwakeningSelector extends PolymerElement {
    static get template() {
        return html`
        <style include="com-theme"></style>
        <style include="com-avl-cal-awakening-selector-style"></style>

        <com-native-bridge
            id="nativeBridge"
            native-bridge-plugin-name="AvailCalendarNavigationPlugin"
            is-embedded="{{isEmbedded}}"
        ></com-native-bridge>

        <div class$="[[_getHeaderContainerClasses(isEmbedded)]]">
            <div id="title">
                <h1>[[title]]</h1>
            </div>
            <template is="dom-if" if="[[isEmbedded]]">
                <div id="closeButton">
                    <a on-click="_closeHybridCalendarWindow">
                        <com-icon
                            value="&#58174;"
                            tabindex="0"
                            role="button"
                        ></com-icon>
                    </a>
                </div>
            </template>
        </div>

        <com-html id="disclaimer" value="[[disclaimer]]"></com-html>

        <template is="dom-if" if="[[segments.length]]">
            <com-radio-group
                selectable="com-button"
                selected="{{selectedSegment}}"
                selected-attribute="active">
                <template is="dom-repeat" items="[[segments]]" as="segment">
                    <com-button
                        toggles
                        name$="[[segment.segmentId]]"
                        role="radio"
                        theme="secondary"
                        aria-active-attribute="aria-checked"
                    >
                        [[segment.text]]
                    </com-button>
                </template>
            </com-radio-group>
        </template>
    `;
    }

    static get is() { return 'com-avl-cal-awakening-selector'; }

    static get properties() {
        return {
            title: {
                type: String,
                value: ''
            },
            disclaimer: {
                type: String,
                value: ''
            },
            segments: {
                type: Array,
                value: []
            },
            selectedSegment: {
                type: String,
                value: '',
                notify: true
            }
        };
    }

    ready() {
        super.ready();
    }

    /**
     * Gets the header container classes depending if the app is embedded or not
     *
     * @param isEmbedded
     * @private
     * @returns {string}
     */
    _getHeaderContainerClasses(isEmbedded) {
        let classesArr = ['headerContainer'];

        if (isEmbedded) {
            classesArr.push('hasCloseButton');
        }

        return classesArr.join(' ');
    }

    /**
     * Closes the page on mobile app
     *
     * @private
     */
    _closeHybridCalendarWindow() {
        this.$.nativeBridge.triggerNativeFunction(
            'dismissButton',
            {}
        );
    }
}
customElements.define(COMAvlCalAwakeningSelector.is, COMAvlCalAwakeningSelector);
